import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetIntegrationsService } from '../get-integrations.service';
import { getIntegrationsAction, getIntegrationsSuccessAction, getIntegrationsFailureAction } from './get-integrations.actions';
import { addIntegrationSuccessAction } from '../../add-integration/store/add-integration.actions';
import { removeIntegrationSuccessAction } from '../../remove-integration/store/remove-integration.actions';
import { updateIntegrationSuccessAction } from '../../update-integration/store/update-integration.actions';
import { zohoSignInSuccessAction, zohoSignOutSuccessAction } from '../../../../zoho-integration/zoho-auth/store/zoho-auth.actions';

@Injectable()
export class GetIntegrationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly getIntegrationsService = inject(GetIntegrationsService);

  getIntegrations$ = createEffect(() => this.actions$.pipe(
    ofType(getIntegrationsAction),
    switchMap(() =>
      this.getIntegrationsService.get().pipe(
        map(integrations => getIntegrationsSuccessAction({ integrations })),
        catchError(error => of(getIntegrationsFailureAction({ error }))),
      )
    )
  ));

  refreshIntegrations$ = createEffect(() => this.actions$.pipe(
    ofType(
      addIntegrationSuccessAction,
      removeIntegrationSuccessAction,
      updateIntegrationSuccessAction,
      zohoSignInSuccessAction,
      zohoSignOutSuccessAction,
    ),
    map(() => getIntegrationsAction()),
  ));
}
